export const EXPORT_CONNECTIONS_BASE_PATH = 'export-connections';
export const EXPORT_CONNECTIONS_TAG = 'export-connections';

export enum ExportConnectionEnum {
  SNOWFLAKE = 'SNOWFLAKE',
  S3 = 'S3',
}

export enum FileTypeEnum {
  CSV = 'CSV',
  PARQUET = 'PARQUET',
}
